import React, { useState } from "react";
import { FaRegTimesCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "../";
import { zoneWidgets } from "../../api";
import { setZoneWidgets } from "../../redux";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

const LearnWidget = ({ zone, sendWidgetCommand }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const selectedZone = useSelector((state) => state.selectedZone);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    id: "",
    request: "",
    serial: "",
  });
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  const learnCommand = () => {
    sendWidgetCommand(zone.commands[1]["command"], zone.uid);
    const zoneId = new FormData();
    zoneId.append("zone", selectedZone);
    zoneWidgets(zoneId, token)
      .then((res) => {
        dispatch(setZoneWidgets(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const deleteLearn = (id, serial) => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: true,
      message: t("آیا از حذف لرن اطمینان دارید؟"),
      type: "Warning",
      question: true,
      id: id,
      request: "deleteLearn",
      serial: serial,
    }));
  };

  return (
    <div className="text-right">
      <div>
        <i className="circleTop icon-plug text-center m-auto"></i>
        <div className="text-center mt-2">
          <p className="m-0">{t("لرن و حذف لرن ویجت")}</p>
        </div>
      </div>
      <div className="my-4">
        <div className="text-center">
          <b className="fn">{zone.caption}</b>
          <p className="fn text-muted mt-2">{zone.genesis}</p>
        </div>
        <div className="my-5">
          <span
            onClick={learnCommand}
            className=" cursor d-block learnBtn1 rounded-circle m-auto d-flex justify-content-center align-items-center"
          >
            <span className="d-block learnBtn2 rounded-circle bg-white d-flex justify-content-center align-items-center">
              <span className="d-block learnBtn3 rounded-circle d-flex justify-content-center align-items-center">
                <p className="fn text-white">{t("لرن ویجت")}</p>
              </span>
            </span>
          </span>
        </div>
        <div>
          <span
            onClick={() => deleteLearn(zone.id, zone.serial)}
            className="cursor d-block deleteLearnBtn m-auto d-flex justify-content-center align-items-center"
          >
            <div className="text-danger ml-3" style={{ fontSize: "20px" }}>
              <FaRegTimesCircle />
            </div>
            <b className="fn">{t("حذف لرن ویجت")}</b>
          </span>
        </div>
      </div>
      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          question={showAlert.question}
          id={showAlert.id}
          request={showAlert.request}
          toggleAlert={toggleAlert}
          serial={showAlert.serial}
        />
      )}
    </div>
  );
};

export { LearnWidget };
